import { render, staticRenderFns } from "./CurrentPositionText.vue?vue&type=template&id=0c007fe9&scoped=true&"
import script from "./CurrentPositionText.vue?vue&type=script&lang=js&"
export * from "./CurrentPositionText.vue?vue&type=script&lang=js&"
import style0 from "./CurrentPositionText.vue?vue&type=style&index=0&id=0c007fe9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c007fe9",
  null
  
)

export default component.exports